import { Link } from "react-router-dom";
import { Page } from "@/components/PublicLayout";
import { t } from "@/lib/i18n";

export default function NotFoundPage() {
  return (
    <Page title={t("common.notFoundTitle")} lede={t("common.notFoundBody")} testId="not-found-page">
      <div className="flex flex-col gap-3 sm:flex-row">
        <Link to="/" className="btn-primary" data-testid="not-found-home">{t("common.goHome")}</Link>
        <Link to="/reach-out" className="btn-secondary">{t("nav.reachOutCta")}</Link>
      </div>
    </Page>
  );
}
